import { render } from "./DebtorJournal.vue?vue&type=template&id=9a49196a&scoped=true"
import script from "./DebtorJournal.vue?vue&type=script&lang=js"
export * from "./DebtorJournal.vue?vue&type=script&lang=js"

import "./DebtorJournal.vue?vue&type=style&index=0&id=9a49196a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Sabir\\Downloads\\Subrogation-Progress\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a49196a"]])

export default __exports__